document.addEventListener('DOMContentLoaded', function () {
  const normalizePath = (path) => {
    return path.replace(/\/$/, '') || '/';
  };

  function highlightActiveMenuItem() {
    const currentPath = normalizePath(window.location.pathname);

    const miniMenus = document.querySelectorAll('.qlf-mini-menu');

    miniMenus.forEach((menu) => {
      const menuItems = menu.querySelectorAll('nav ul li');

      menuItems.forEach((item) => {
        item.classList.remove('active');
      });

      menuItems.forEach((item) => {
        const link = item.querySelector('a');
        if (link) {
          const linkUrl = new URL(link.href);
          const linkPath = normalizePath(linkUrl.pathname);

          if (currentPath === linkPath) {
            item.classList.add('active');
          }
        }
      });
    });
  }

  function updateFadesForMenu(menuRoot) {
    const nav = menuRoot.querySelector('nav');
    const columns = menuRoot.querySelector('.row .columns');
    if (!nav || !columns) return;

    const atStart = nav.scrollLeft <= 0;
    const atEnd = Math.ceil(nav.scrollLeft + nav.clientWidth) >= nav.scrollWidth;
    const noOverflow = nav.scrollWidth <= nav.clientWidth;

    if (noOverflow) {
      columns.classList.add('no-left-fade', 'no-right-fade');
      columns.classList.add('no-fade');
      return;
    }

    if (atStart) {
      columns.classList.add('no-left-fade');
    } else {
      columns.classList.remove('no-left-fade');
    }

    if (atEnd) {
      columns.classList.add('no-right-fade');
      columns.classList.add('no-fade');
    } else {
      columns.classList.remove('no-right-fade');
      columns.classList.remove('no-fade');
    }
  }

  function initFadeHandling() {
    const miniMenus = document.querySelectorAll('.qlf-mini-menu');
    miniMenus.forEach((menuRoot) => {
      const nav = menuRoot.querySelector('nav');
      if (!nav) return;

      if (nav.dataset.nudging === '1') return;

      updateFadesForMenu(menuRoot);

      nav.addEventListener('scroll', () => updateFadesForMenu(menuRoot), { passive: true });

      const rerun = () => updateFadesForMenu(menuRoot);
      window.addEventListener('resize', rerun);
      window.addEventListener('load', rerun);
    });
  }

  function scrollToActiveMenuItem() {
    const miniMenus = document.querySelectorAll('.qlf-mini-menu');

    miniMenus.forEach((menuRoot) => {
      const nav = menuRoot.querySelector('nav');
      if (!nav) return;
      if (nav.dataset.nudging === '1') return;

      const activeLi =
        nav.querySelector('li.active') ||
        nav.querySelector('a[aria-current="page"]')?.closest('li');
      if (!activeLi) return;

      if (nav.scrollWidth <= nav.clientWidth) return;

      const itemCenter = activeLi.offsetLeft + activeLi.offsetWidth / 2;
      let targetLeft = itemCenter - nav.clientWidth / 2;
      targetLeft = Math.max(0, Math.min(targetLeft, nav.scrollWidth - nav.clientWidth));

      if (Math.abs(nav.scrollLeft - targetLeft) < 2) return;

      try {
        nav.scrollTo({ left: targetLeft, behavior: 'smooth' });
      } catch (e) {
        nav.scrollLeft = targetLeft;
      }

      setTimeout(() => updateFadesForMenu(menuRoot), 100);
      setTimeout(() => updateFadesForMenu(menuRoot), 250);
      setTimeout(() => updateFadesForMenu(menuRoot), 500);
    });
  }

  highlightActiveMenuItem();
  requestAnimationFrame(() => scrollToActiveMenuItem());
  window.addEventListener('load', scrollToActiveMenuItem);

  initFadeHandling();

  (function initArrowControls() {
    document.querySelectorAll('.qlf-mini-menu').forEach((menuRoot) => {
      const nav = menuRoot.querySelector('nav');
      const leftBtn = menuRoot.querySelector('.qlf-mini-menu__arrow--left');
      const rightBtn = menuRoot.querySelector('.qlf-mini-menu__arrow--right');
      if (!nav || !leftBtn || !rightBtn) return;

      const getStep = () => Math.max(120, Math.round(nav.clientWidth * 0.6));

      const doScroll = (dir) => {
        const step = getStep() * dir;
        const target = nav.scrollLeft + step;
        try {
          nav.scrollTo({ left: target, behavior: 'smooth' });
        } catch (e) {
          nav.scrollLeft = target;
        }
      };

      leftBtn.addEventListener('click', () => doScroll(-1));
      rightBtn.addEventListener('click', () => doScroll(1));

      const update = () => {
        const noOverflow = nav.scrollWidth <= nav.clientWidth;

        const atStart = nav.scrollLeft <= 0;
        const atEnd = Math.ceil(nav.scrollLeft + nav.clientWidth) >= nav.scrollWidth;

        if (noOverflow) {
          leftBtn.style.display = 'none';
          rightBtn.style.display = 'none';
          return;
        }

        leftBtn.style.display = atStart ? 'none' : '';
        rightBtn.style.display = atEnd ? 'none' : '';
      };

      update();
      nav.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
    });
  })();
});
